__webpack_require__.p = "/user-interface-refactor-stateful-components/referrals-hub/";